import { stationAdminKeys } from "./useStationActivity";

/**
 * Query-key factory for the Internal Affairs compliance feature. Built on
 * stationAdminKeys.all so a station-admin-wide invalidation stays coherent
 * across the Overview and Internal Affairs tabs.
 */
export const iaKeys = {
  all: [...stationAdminKeys.all, "ia"] as const,
  docs: (orgId: string) => [...iaKeys.all, "docs", orgId] as const,
  runs: (orgId: string) => [...iaKeys.all, "runs", orgId] as const,
  run: (orgId: string, runId: string) =>
    [...iaKeys.all, "run", orgId, runId] as const,
  /** Report picker's own window — deliberately NOT the dashboard window keys,
   *  so the picker's 30-day fetch never collides with the Overview cache. */
  reports: (orgId: string, start: string, end: string) =>
    [...iaKeys.all, "reports", orgId, start, end] as const,
};
